import React from 'react';
import ObjCommonFilterSelection from 'src/component/custom/ObjCommonFilterSelection';
import { SearchBom } from '../Admin/Bom/SearchBom';
import { AdminBomList } from '../Admin/Bom/AdminBomList';
import ShowAlert from 'src/component/Global/ShowAlert';
import AdminConsoleHeader from "../Admin/AdminConsoleHeader";

const BomManagementTab = () => {

    return (
        <>
            <div className='adminconsole-container'>
                <AdminConsoleHeader title='BOM VIEWER' tab='MAIN' header="SFDC BOM ID MANAGER" />
                <div className="bs5 row mt-2">
                    <div className='col-12'>
                        <ShowAlert doNotShow={['accessDenied']}/>
                    </div>
                </div>

                <div className='accountdetails mt-2 bom-management'>
                    <div className='acsearchuser'>
                        <SearchBom />
                    </div>
                    <ObjCommonFilterSelection />
                    <div>
                        <AdminBomList />
                    </div>
                </div>

            </div>
        </>
    );
}

export default BomManagementTab;